export default "__VITE_ASSET__BaYYtBBk__ 194w";